import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class SegmentationService {
  environment = EnvironmentService.environment;

  constructor(private httpClient: HttpClient) { }

  runSegmentation(obj = {}) {
    return this.httpClient.post(this.environment.ClusterBaseUrl + '/segmentation-api/run_segmentation/', obj);
  }

  fetchMembershipSegments(user_id: number, file_name: string, version_no: string, run_tab_index: any, matrix_columns: any) {
    return this.httpClient.get(`${this.environment.ClusterBaseUrl}/segmentation-api/fetch-statistics-table/?user_id=${user_id}&file_name=${file_name}&version_no=${version_no}&run_tab_index=${run_tab_index}&matrix_columns=${matrix_columns}`);
  }

  fetchAllSegments(user_id: number, file_name: string, version_no: string, run_tab_index: any) {
    return this.httpClient.get(`${this.environment.ClusterBaseUrl}/segmentation-api/fetch-all-segments/?user_id=${user_id}&file_name=${file_name}&version_no=${version_no}&run_tab_index=${run_tab_index}`)
  }

  fetchSegmentDatById(user_id: string, page: number, file_name: string, version_no: string, run_tab_index: any, search_by: string, search_value: string, segmentaion_id: number, sort_by: string, sort_direction: string) {
    return this.httpClient.get(`${this.environment.ClusterBaseUrl}/segmentation-api/fetch-segment-data/?user_id=${user_id}&file_name=${file_name}&version_no=${version_no}&run_tab_index=${run_tab_index}&search_by=${search_by}&search_value=${search_value}&segmentation_id=${segmentaion_id}&page=${page}&sort_by=${sort_by}&sort_direction=${sort_direction}`)
  }

  applyAdjustment(obj: any = {}) {
    return this.httpClient.post(this.environment.ClusterBaseUrl + '/segmentation-api/apply-adjustment/', obj);
  }

  resetAdjustments(obj: any = {}) {
    return this.httpClient.post(this.environment.ClusterBaseUrl + '/segmentation-api/reset-adjustment/', obj);
  }

  saveRun(obj = {}) {
    return this.httpClient.post(this.environment.ClusterBaseUrl + '/segmentation-api/save-run/', obj);
  }

  fetchAlreadySavedRuns(user_id: number, file_name: string, version_no: string) {
    return this.httpClient.get(this.environment.ClusterBaseUrl + `/segmentation-api/run-tabs/?user_id=${user_id}&file_name=${file_name}&version_no=${version_no}`);
  }

  deleteSavedRun(obj = {}) {
    return this.httpClient.post(this.environment.ClusterBaseUrl + `/segmentation-api/run-tabs/`, obj);
  }

  UpdateSavedRun(obj = {}) {
    return this.httpClient.put(this.environment.ClusterBaseUrl + `/segmentation-api/run-tabs/`, obj);
  }

  downloadSegmentationRunsData(obj = {}) {
    return this.httpClient.post(this.environment.ClusterBaseUrl + `/segmentation-api/download-membership-segments-file/`, obj);
  }

  fetchbarChartData(user_id: number, file_name: string, version_no: string, run_tab_index: number, groupby: string) {
    return this.httpClient.get(this.environment.ClusterBaseUrl + `/segmentation-api/bar-chart-data/?file_name=${file_name}&version_no=${version_no}&user_id=${user_id}&run_tab_index=${run_tab_index}&groupby=${groupby}`);
  }

  fetchScatterPlotData(user_id: number, file_name: string, version_no: string, run_tab_index: number, xVariable: string, yVariable: string, segmentationIds: any) {
    return this.httpClient.get(this.environment.ClusterBaseUrl + `/segmentation-api/scatter-plot-data/?file_name=${file_name}&version_no=${version_no}&user_id=${user_id}&run_tab_index=${run_tab_index}&x_variable=${xVariable}&y_variable=${yVariable}&segmentation_ids=${segmentationIds}`);
  }

  fetchBubblePlotData(user_id: number, file_name: string, version_no: string, run_tab_index: number, groupby: string, variableOne: string, variableTwo: string) {
    return this.httpClient.get(this.environment.ClusterBaseUrl + `/segmentation-api/bubble-plot-data/?file_name=${file_name}&version_no=${version_no}&user_id=${user_id}&run_tab_index=${run_tab_index}&groupby=${groupby}&variable_one=${variableOne}&variable_two=${variableTwo}`);
  }

  fetchSpiderPlotData(user_id: number, file_name: string, version_no: string, run_tab_index: number) {
    return this.httpClient.get(this.environment.ClusterBaseUrl + `/segmentation-api/spider-chart-data/?file_name=${file_name}&version_no=${version_no}&user_id=${user_id}&run_tab_index=${run_tab_index}`);
  }
}
